<template>
    <Breadcrumbs main="Charts" title="Google Chart" />
    <div class="container-fluid">
        <div class="row">
            <googleChart />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const googleChart = defineAsyncComponent(() => import("@/components/theme/charts/google/googleChart.vue"))

</script>